import React, {useState} from 'react';
import * as S from './EndOfBuses.styles';
import Icon from '../../../../../stories/core-components/IconsSelector';

const EndOfBuses = props => {
  const {operatorName,cb} = props;
  return (
    <S.EndOfBuses>
<S.ToggleText>End of {operatorName} Buses</S.ToggleText>
<div  onClick={(evt)=>{
  evt.preventDefault();
  cb();
}}>
      <S.ToggleLink >Hide Buses</S.ToggleLink>
      <Icon 
        name="DropArrowIcon"
        styleProps={{width: '1rem', height: '1rem', fill: '#2276e3',
      transform:'rotate(180deg)'
      }}
      ></Icon>
      </div>
    </S.EndOfBuses>
  );
};

export default EndOfBuses;
